let keepChecking = true;
const checkInterval = 60000;

function checkSession() {
  if (!keepChecking) return;

  fetch('/index/is-it-time-to-kill-sso-session')
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => {
      if (data.success === false) {
        keepChecking = false;
      } else if (data.success === true && data.keepSession === false) {
        window.location.href = '/user/logout';
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}
setInterval(checkSession, checkInterval);
